<template>
  <div>
    <router-view v-if="!loader && letter.id" />
    <div v-else>
      <b-spinner />
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import quoteDistributionOtmModule from '@/store/quote-distribution-otm'

export default {
  name: 'Get',
  components: {
    BSpinner,
  },
  data() {
    return {
      error: null,
      loader: false,
    }
  },
  computed: {
    letter() {
      return this.$store.state[this.MODULE_NAME].letter
    },
  },
  created() {
    this.loader = true
    this.$store.dispatch(`${this.MODULE_NAME}/get`, this.$route.params.id).catch(() => {
      this.error = true
    }).finally(() => {
      this.loader = false
    })
  },
  setup() {
    const MODULE_NAME = 'quoteDistributionOtm'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, quoteDistributionOtmModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    return {
      MODULE_NAME,
    }
  },
}
</script>

<style scoped>

</style>
